export const IncidentTypeMapArr = [
    {
        incidentType: 'INCIDENT_CROWD',
        type: 'Crowd',
        alertDetailI18n: 'incidentCrowd',
        alarmCenterI18n: 'incidentCrowd',
        alarmDetailI18n: 'lastedNumber',
    },
    {
        incidentType: 'INCIDENT_QUEUE_TIMING',
        type: 'Crowd',
        alertDetailI18n: 'incidentQueueTiming',
        alarmCenterI18n: 'incidentQueueTiming',
        alarmDetailI18n: 'estimatedQueueTime',
    },
    {
        incidentType: 'INCIDENT_QUEUE_COUNTING',
        type: 'Crowd',
        alertDetailI18n: 'incidentQueueCounting',
        alarmCenterI18n: 'incidentQueueCounting',
        alarmDetailI18n: 'lastedNumber',
    },
    {
        incidentType: 'INCIDENT_OFF_DUTY',
        type: 'Crowd',
        alertDetailI18n: 'incidentOffDuty',
        alarmCenterI18n: 'incidentOffDuty',
        alarmDetailI18n: 'lastedTime',
    },
    {
        incidentType: 'INCIDENT_STRAND',
        type: 'Crowd',
        alertDetailI18n: 'crowdRetention',
        alarmCenterI18n: 'crowdRetention',
        alarmDetailI18n: 'lastedNumber',
    },
    {
        incidentType: 'INCIDENT_CROSS_LINE',
        type: 'Crowd',
        alertDetailI18n: 'crowdCrossLine',
        alarmCenterI18n: 'crowdCrossLine',
        alarmDetailI18n: 'lastedNumber',
    },
    {
        incidentType: 'INCIDENT_RETROGRADE',
        type: 'Crowd',
        alertDetailI18n: 'crowdCounterflow',
        alarmCenterI18n: 'crowdCounterflow',
        alarmDetailI18n: 'lastedNumber',
    },
    {
        incidentType: 'INCIDENT_INVADE',
        type: 'Crowd',
        alertDetailI18n: 'crowdIntrusion',
        alarmCenterI18n: 'crowdIntrusion',
        alarmDetailI18n: 'lastedNumber',
    },
    {
        incidentType: 'INCIDENT_SOCIAL_DISTANCE',
        type: 'Crowd',
        alertDetailI18n: 'closeSocialDistance',
        alarmCenterI18n: 'closeSocialDistance',
        alarmDetailI18n: 'lastedNumber',
        incidentComponent: 'details-social-distance',
    },
    {
        incidentType: 'INCIDENT_CONGREGATE',
        type: 'Crowd',
        alertDetailI18n: 'crowdGather',
        alarmCenterI18n: 'crowdGather',
        alarmDetailI18n: 'lastedNumber',
        incidentComponent: 'details-gather-scatter',
    },
    {
        incidentType: 'INCIDENT_SCATTER',
        type: 'Crowd',
        alertDetailI18n: 'crowdScatter',
        alarmCenterI18n: 'crowdScatter',
        alarmDetailI18n: 'lastedNumber',
        incidentComponent: 'details-gather-scatter',
    },
    {
        incidentType: 'FACE_MATCH',
        type: 'Face',
        alertDetailI18n: 'faceComparison',
        alarmCenterI18n: 'faceComparison',
        incidentComponent: 'details-face',
    },
    {
        incidentType: 'INCIDENT_FACE_UNMATCHED',
        type: 'Face',
        alertDetailI18n: 'unmatchedFaceComparison',
        alarmCenterI18n: 'unmatchedFaceComparison',
        incidentComponent: 'details-face',
    },
    {
        incidentType: 'OBJECT_FACE',
        type: 'Face',
        alertDetailI18n: 'faceComparison',
        alarmCenterI18n: 'faceComparison',
        incidentComponent: 'details-face',
    },
    {
        incidentType: 'FACE_PEDESTRIAN',
        type: 'Face',
        alertDetailI18n: 'faceBodyRecognition',
        alarmCenterI18n: 'faceBodyRecognition',
        incidentComponent: 'details-face',
    },
    {
        incidentType: 'OBJECT_AUTOMOBILE',
        type: 'Automobile',
        alertDetailI18n: 'faceBodyRecognition',
        alarmCenterI18n: 'faceBodyRecognition',
        incidentComponent: 'details-face',
    },
    {
        incidentType: 'OBJECT_PEDESTRIAN',
        type: 'Face',
        alertDetailI18n: 'faceBodyRecognition',
        alarmCenterI18n: 'faceBodyRecognition',
        incidentComponent: 'details-face',
    },
    {
        incidentType: 'INCIDENT_ST_ROAD_POTHOLE',
        type: 'Pavement',
        alertDetailI18n: 'potholeConfidence',
        alarmCenterI18n: 'pavementDefects',
        alarmDetailI18n: 'potholeConfidence',
        incidentComponent: 'details-road',
    },
    {
        incidentType: 'INCIDENT_ST_ROAD_ALLIGATOR_CRACK',
        type: 'Pavement',
        alertDetailI18n: 'alligatorConfidence',
        alarmCenterI18n: 'pavementDefects',
        alarmDetailI18n: 'alligatorConfidence',
        incidentComponent: 'details-road',
    },
    {
        incidentType: 'INCIDENT_ST_ROAD_RAVELING',
        type: 'Pavement',
        alertDetailI18n: 'ravelingConfidence',
        alarmCenterI18n: 'pavementDefects',
        alarmDetailI18n: 'ravelingConfidence',
        incidentComponent: 'details-road',
    },
    {
        incidentType: 'INCIDENT_ST_ROAD_LINEAR_CRACK',
        type: 'Pavement',
        alertDetailI18n: 'linearConfidence',
        alarmCenterI18n: 'pavementDefects',
        alarmDetailI18n: 'linearConfidence',
        incidentComponent: 'details-road',
    },
    {
        incidentType: 'INCIDENT_ST_ROAD_ROAD_SUBSIDENCE',
        type: 'Waste',
        alertDetailI18n: 'subsidenceConfidence',
        alarmCenterI18n: 'pavementDefects',
        alarmDetailI18n: 'subsidenceConfidence',
        incidentComponent: 'details-road',
    },
    {
        incidentType: 'INCIDENT_ST_TRASH_ON_THE_STREET',
        type: 'Waste',
        alertDetailI18n: 'exposeConfidence',
        alarmCenterI18n: 'wasteDetection',
        alarmDetailI18n: 'exposeConfidence',
        incidentComponent: 'details-waste',
    },
    {
        incidentType: 'INCIDENT_ST_TRASH_BIN_FULL',
        type: 'Conduct',
        alertDetailI18n: 'overFillConfidence',
        alarmCenterI18n: 'wasteDetection',
        alarmDetailI18n: 'overFillConfidence',
        incidentComponent: 'details-waste',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_HATLESS',
        type: 'Conduct',
        alertDetailI18n: 'hatlessConfidence',
        alarmCenterI18n: 'codeOfConduct',
        alarmDetailI18n: 'hatlessConfidence',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_NOT_WEARING_UNIFORM',
        type: 'Conduct',
        alertDetailI18n: 'notWearingUniformConfidence',
        alarmCenterI18n: 'codeOfConduct',
        alarmDetailI18n: 'notWearingUniformConfidence',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_SHIRTLESS',
        type: 'Conduct',
        alertDetailI18n: 'shirtlessConfidence',
        alarmCenterI18n: 'codeOfConduct',
        alarmDetailI18n: 'shirtlessConfidence',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_NOT_WEARING_MASK',
        type: 'Conduct',
        alertDetailI18n: 'notWearingMaskConfidence',
        alarmCenterI18n: 'codeOfConduct',
        alarmDetailI18n: 'notWearingMaskConfidence',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_SMOKING',
        type: 'Conduct',
        alertDetailI18n: 'smokingConfidence',
        alarmCenterI18n: 'codeOfConduct',
        alarmDetailI18n: 'smokingConfidence',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_PLAYING_WITH_CELLPHONE',
        type: 'Conduct',
        alertDetailI18n: 'playPhoneConfidence',
        alarmCenterI18n: 'codeOfConduct',
        alarmDetailI18n: 'playPhoneConfidence',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_MAKING_PHONE_CALLS',
        type: 'Conduct',
        alertDetailI18n: 'phoneCallConfidence',
        alarmCenterI18n: 'codeOfConduct',
        alarmDetailI18n: 'phoneCallConfidence',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_TRASH_CONTAINER_OPEN',
        type: 'Waste',
        alertDetailI18n: 'trashBinUncoverConfidence',
        alarmCenterI18n: 'wasteDetection',
        alarmDetailI18n: 'trashBinUncoverConfidence',
        incidentComponent: 'details-waste',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_TOUCHING_FACE',
        type: 'Conduct',
        alertDetailI18n: 'touchFaceConfidence',
        alarmCenterI18n: 'codeOfConduct',
        alarmDetailI18n: 'touchFaceConfidence',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_EATING',
        type: 'Conduct',
        alertDetailI18n: 'eatFoodConfidence',
        alarmCenterI18n: 'codeOfConduct',
        alarmDetailI18n: 'eatFoodConfidence',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_PEST_MOUSE',
        type: 'Conduct',
        alertDetailI18n: 'mouseDetectConfidence',
        alarmCenterI18n: 'animalsInsects',
        alarmDetailI18n: 'mouseDetectConfidence',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_PEST_CAT',
        type: 'Conduct',
        alertDetailI18n: 'catDetectConfidence',
        alarmCenterI18n: 'animalsInsects',
        alarmDetailI18n: 'catDetectConfidence',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_PEST_DOG',
        type: 'Conduct',
        alertDetailI18n: 'dogDetectConfidence',
        alarmCenterI18n: 'animalsInsects',
        alarmDetailI18n: 'dogDetectConfidence',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_DETECT_TABLE_HYGIENE',
        type: 'Conduct',
        alertDetailI18n: 'foodResidue',
        alarmCenterI18n: 'tableDetection',
        alarmDetailI18n: 'foodResidue',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_KITCHEN_STAFF_DETECT_CONTAINER_OPEN',
        type: 'Conduct',
        alertDetailI18n: 'lidUncoverDetectConfidence',
        alarmCenterI18n: 'kitchen',
        alarmDetailI18n: 'lidUncoverDetectConfidence',
        incidentComponent: 'details-kitchen',
    },
    {
        incidentType: 'INCIDENT_ST_CITY_FIRE',
        type: 'Conduct',
        alertDetailI18n: 'fireDetection',
        alarmCenterI18n: 'kitchen',
        alarmDetailI18n: 'fireDetection',
        incidentComponent: 'fire-detection',
    },
    {
        incidentType: 'INCIDENT_CROWD_ABNORMAL_BEHAVIOR_FALL',
        type: 'Abnormal',
        alertDetailI18n: 'fallDownConfidence',
        alarmCenterI18n: 'abnormalBehavior',
        alarmDetailI18n: 'fallDownConfidence',
        incidentComponent: 'abnormal-behavior',
    },
    {
        incidentType: 'INCIDENT_CROWD_ABNORMAL_BEHAVIOR_FIGHT',
        type: 'Abnormal',
        alertDetailI18n: 'fightingConfidence',
        alarmCenterI18n: 'abnormalBehavior',
        alarmDetailI18n: 'fightingConfidence',
        incidentComponent: 'abnormal-behavior',
    },
    {
        incidentType: 'INCIDENT_TRAFFIC_RETROGRADE',
        type: 'Traffic',
        alertDetailI18n: 'trafficReverseConfidence',
        alarmCenterI18n: 'traffic',
        alarmDetailI18n: 'trafficReverseConfidence',
        incidentComponent: 'traffic-confidence',
    },
    {
        incidentType: 'INCIDENT_TRAFFIC_ILLEGAL_STOP',
        type: 'Traffic',
        alertDetailI18n: 'trafficIllegalStopConfidence',
        alarmCenterI18n: 'traffic',
        alarmDetailI18n: 'trafficIllegalStopConfidence',
        incidentComponent: 'traffic-confidence',
    },
    {
        incidentType: 'INCIDENT_TRAFFIC_CONGESTION',
        type: 'Traffic',
        alertDetailI18n: 'congestion',
        alarmCenterI18n: 'traffic',
        alarmDetailI18n: 'congestion',
        incidentComponent: 'traffic',
    },
    {
        incidentType: 'INCIDENT_TRAFFIC_INTRUSION',
        type: 'Traffic',
        alertDetailI18n: 'trafficIntrusion',
        alarmCenterI18n: 'traffic',
        alarmDetailI18n: 'trafficIntrusion',
        incidentComponent: 'traffic',
    },
    {
        incidentType: 'INCIDENT_PEDESTRIAN_ATTRIBUTE_MATCHED',
        type: 'Body',
        alertDetailI18n: 'matchedBody',
        alarmCenterI18n: 'matchedBody',
        alarmDetailI18n: 'matchedBody',
        incidentComponent: 'details-face',
        confidenceComponent: '',
        snapBackAndForth: 'CAPTURE',
        annotation: 'pedestrianAnnotation',
    },
    {
        incidentType: 'INCIDENT_PEDESTRIAN_ATTRIBUTE_UNMATCHED',
        type: 'Body',
        alertDetailI18n: 'unmatchedBody',
        alarmCenterI18n: 'unmatchedBody',
        alarmDetailI18n: 'unmatchedBody',
        incidentComponent: 'details-face',
        confidenceComponent: '',
        snapBackAndForth: 'CAPTURE',
        annotation: 'pedestrianAnnotation',
    },
    {
        incidentType: 'INCIDENT_AUTOMOBILE_LICENSE_PLATE_MATCHED',
        type: 'Vehicle',
        alertDetailI18n: 'matchedLicensePlate',
        alarmCenterI18n: 'matchedLicensePlate',
        alarmDetailI18n: 'matchedLicensePlate',
        incidentComponent: 'details-face',
        confidenceComponent: '',
        snapBackAndForth: 'CAPTURE',
        annotation: 'automobileAnnotation',
    },
    {
        incidentType: 'INCIDENT_AUTOMOBILE_LICENSE_PLATE_UNMATCHED',
        type: 'Vehicle',
        alertDetailI18n: 'unmatchedLicensePlate',
        alarmCenterI18n: 'unmatchedLicensePlate',
        alarmDetailI18n: 'unmatchedLicensePlate',
        incidentComponent: 'details-face',
        confidenceComponent: '',
        snapBackAndForth: 'CAPTURE',
        annotation: 'automobileAnnotation',
    },
    {
        incidentType: 'INCIDENT_AUTOMOBILE_ATTRIBUTE_MATCHED',
        type: 'Vehicle',
        alertDetailI18n: 'matchedVehicleAttribute',
        alarmCenterI18n: 'matchedVehicleAttribute',
        alarmDetailI18n: 'matchedVehicleAttribute',
        incidentComponent: 'details-face',
        confidenceComponent: '',
        snapBackAndForth: 'CAPTURE',
        annotation: 'automobileAnnotation',
    },
    {
        incidentType: 'INCIDENT_AUTOMOBILE_ATTRIBUTE_UNMATCHED',
        type: 'Vehicle',
        alertDetailI18n: 'unmatchedVehicleAttribute',
        alarmCenterI18n: 'unmatchedVehicleAttribute',
        alarmDetailI18n: 'unmatchedVehicleAttribute',
        incidentComponent: 'details-face',
        confidenceComponent: '',
        snapBackAndForth: 'CAPTURE',
        annotation: 'automobileAnnotation',
    },
    {
        incidentType: 'INCIDENT_UNKNOWN_OBJECT_RETENTION',
        type: 'Object',
        alertDetailI18n: 'unidentifiedObjectRetention',
        alarmCenterI18n: 'unidentifiedObjectRetention',
        alarmDetailI18n: 'lastedTime',
        incidentComponent: '',
        confidenceComponent: '',
        annotation: 'objectsDetectionAnnotation',
    },
    {
        incidentType: 'OBJECT_HUMAN_POWERED_VEHICLE',
        type: 'MotorBike',
        alertDetailI18n: 'unidentifiedObjectRetention',
        alarmCenterI18n: 'unidentifiedObjectRetention',
        incidentComponent: 'details-bike',
    },
    {
        incidentType: 'INCIDENT_EVERYTHING_MATCHED',
        type: 'Everything',
        alertDetailI18n: 'alalysisEverythingMatched',
        alarmCenterI18n: 'alalysisEverythingMatched',
        incidentComponent: 'details-everything',
    },
    {
        incidentType: 'INCIDENT_EVERYTHING_UNMATCHED',
        type: 'Everything',
        alertDetailI18n: 'alalysisEverythingUnMatched',
        alarmCenterI18n: 'alalysisEverythingUnMatched',
        incidentComponent: 'details-everything',
    },
    {
        incidentType: 'OBJECT_ALGO',
        type: 'Everything',
        alertDetailI18n: 'alalysisEverythingUnMatched',
        alarmCenterI18n: 'alalysisEverythingUnMatched',
        incidentComponent: 'details-everything',
    },
    {
        incidentType: 'OBJECT_EVERYTHING',
        type: 'Everything',
        alertDetailI18n: 'alalysisEverythingUnMatched',
        alarmCenterI18n: 'alalysisEverythingUnMatched',
        incidentComponent: 'details-everything',
    },
];
export const trafficType = [
    'INCIDENT_TRAFFIC_INTRUSION',
    'INCIDENT_TRAFFIC_CONGESTION',
    'INCIDENT_TRAFFIC_RETROGRADE',
    'INCIDENT_TRAFFIC_ILLEGAL_STOP',
];
export const resultType = {
    event: ['eventType', 'captureEvent', 'device'],
    features: ['contrast', 'features', 'time', 'device'],
    fileCluster: ['smallImage', 'features', 'time', 'device'],
    bigData: ['smallImage', 'features', 'time', 'device'],
    time: ['smallImage', 'features', 'time', 'device'],
    crowdEvent: ['eventType', 'time', 'device'],
    car: ['smallImage', 'features', 'time', 'device', 'number'],
    Automobile: ['features', 'time', 'device', 'number'],
    ObjectEverything: ['smallImage', 'time', 'device'],
};
export const spaceTimeType = [
    'OBJECT_FACE',
    'OBJECT_PEDESTRIAN',
    'OBJECT_AUTOMOBILE',
    'EVENT_FACE',
    'OBJECT_HUMAN_POWERED_VEHICLE',
];
export const confidenceShowList = [
    'details-waste',
    'details-road',
    'details-kitchen',
    'abnormal-behavior',
    'traffic-confidence',
];
export const crowdAndIndividual = [
    'INCIDENT_CROWD',
    'INCIDENT_QUEUE_TIMING',
    'INCIDENT_QUEUE_COUNTING',
    'INCIDENT_OFF_DUTY',
    'INCIDENT_STRAND',
    'INCIDENT_RETROGRADE',
    'INCIDENT_INVADE',
    'INCIDENT_SOCIAL_DISTANCE',
    'INCIDENT_CONGREGATE',
    'INCIDENT_SCATTER',
];
export const faceList = ['FACE_MATCH', 'FACE_PEDESTRIAN'];
export const showConfidence = [
    'FACE_MATCH',
    'FACE_PEDESTRIAN',
    'INCIDENT_ST_ROAD_POTHOLE',
    'INCIDENT_ST_ROAD_ALLIGATOR_CRACK',
    'INCIDENT_ST_ROAD_RAVELING',
    'INCIDENT_ST_ROAD_LINEAR_CRACK',
    'INCIDENT_ST_ROAD_ROAD_SUBSIDENCE',
    'INCIDENT_ST_TRASH_ON_THE_STREET',
    'INCIDENT_ST_TRASH_BIN_FULL',
    'INCIDENT_ST_KITCHEN_STAFF_HATLESS',
    'INCIDENT_ST_KITCHEN_STAFF_NOT_WEARING_UNIFORM',
    'INCIDENT_ST_KITCHEN_STAFF_SHIRTLESS',
    'INCIDENT_ST_KITCHEN_STAFF_NOT_WEARING_MASK',
    'INCIDENT_ST_KITCHEN_STAFF_SMOKING',
    'INCIDENT_ST_KITCHEN_STAFF_PLAYING_WITH_CELLPHONE',
    'INCIDENT_ST_KITCHEN_STAFF_MAKING_PHONE_CALLS',
    'INCIDENT_ST_TRASH_CONTAINER_OPEN',
    'INCIDENT_ST_KITCHEN_STAFF_TOUCHING_FACE',
    'INCIDENT_ST_KITCHEN_STAFF_EATING',
    'INCIDENT_ST_KITCHEN_STAFF_PEST_MOUSE',
    'INCIDENT_ST_KITCHEN_STAFF_PEST_CAT',
    'INCIDENT_ST_KITCHEN_STAFF_PEST_DOG',
    'INCIDENT_ST_KITCHEN_STAFF_DETECT_TABLE_HYGIENE',
    'INCIDENT_ST_KITCHEN_STAFF_DETECT_CONTAINER_OPEN',
    'INCIDENT_ST_CITY_FIRE',
    'INCIDENT_CROWD_ABNORMAL_BEHAVIOR_FALL',
    'INCIDENT_CROWD_ABNORMAL_BEHAVIOR_FIGHT',
    'INCIDENT_TRAFFIC_RETROGRADE',
    'INCIDENT_TRAFFIC_ILLEGAL_STOP',
];
